var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.chartData).length > 0)?_c('Bar',{ref:"barChart",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }